import ListOfReservations from './ListOfReservations'

export default ListOfReservations
